import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'security-key-dialog',
  templateUrl: './security-key-dialog.component.html',
  styleUrls: ['./security-key-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityKeyDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<SecurityKeyDialogComponent>) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
